import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import './CarDetail.css'
import { Badge, Button, Col, Row, Label, Input, UncontrolledTooltip, FormGroup } from 'reactstrap'
import moment from 'moment-timezone'
import { Link } from 'react-router-dom'
import toTitleCase from '../../Functions/toTitleCase'
import { CarDetailQuery, AllCarModelGroupTypes, AllCarModelsQuery, AllBranchesQuery, AllCarLocationsQuery } from './Queries'
import { UpdateCarMutation, CreateDailyMileageMutation } from "./Mutations"
import InstallEquipment from './EquipmentTab/InstallEquipment'
import Loader from "../../Material/Loader"
import renderEnumToInt from '../../Functions/renderEnumToInt'
import DatetimeRenderer from "../../Material/DatetimeRenderer"
import CopyToClipboard from "../../Material/CopyToClipboard"
import NotesHistory from "../../Material/NotesHistory/NotesHistory"

import withApolloClient from '../../withApolloClient'

import { HasPermissionsQuery } from "../../Functions/querys"
import ClobberDetailsModal from "./Integrations/ClobberDetailsModal"

const enableDisableHistoryTable = [
    { id: "type", name: "Type", sortable: false },
    { id: "dateAdded", name: "Date Added", sortable: false },
    { id: "status", name: "Status", sortable: false },
    { id: "createdBy", name: "Created By", sortable: true },
]

class OverviewTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            showEdit: "",
            input: {},
            openModal: "",
            activeReservation: this.props.car &&
                this.props.car.carReservation &&
                this.props.car.carReservation.edges &&
                this.props.car.carReservation.edges.length > 0 ?
                this.props.car.carReservation.edges.find(reservation => reservation.node.status === "Open") : null,
            editField: "",
            carModelGroups: [],
            carStages: null,
            trackerId: null,
            command: null,
        }
    }
    fetchMetaData = (metadata = null, name) => {
        if (!metadata || metadata === "")
            return
        try {
            metadata = JSON.parse(metadata.replace(/'/g, '"'))
        } catch {
            metadata = null
        }
        return metadata && metadata[name] ? metadata[name] : null
    }
    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.car !== this.props.car || prevProps.allCarModels !== this.props.allCarModels || prevProps.carStages !== this.props.carStages) {
            let activeReservation = this.props.car && this.props.car.carReservation && this.props.car.carReservation.edges.length > 0 ? this.props.car.carReservation.edges.find(reservation => reservation.node.status === "Open") : null
            if (this.props && this.props.allCarModels && this.props.allCarModels.edges && this.props.allCarModels.edges.length > 0) {
                let groups = this.props.allCarModels.edges.filter(model => this.props.car && this.props.car.carModel && model.node.name === this.props.car.carModel.name && model.node.series === this.props.car.carModel.series && model.node.make === this.props.car.carModel.make).map(model => model.node.groupType)
                if (groups) groups = groups.filter(group => group ? group : false)
                this.setState({ carModelGroups: groups })
            }
            this.setState({ activeReservation })
        }
    }
    editField(type, id) {
        if (id) {
            this.setState({ [type]: id, value: id })
        }
        if (type === this.state.editField) {
            this.setState({ error: null })
        }
        this.setState({ editField: type === this.state.editField ? "" : type })
    }
    updateInput = (e) => {
        let value = e.target.value
        this.setState({ value: value })
    };
    updateCar = (carId, name, value) => {
        let defValue = this.state[name]
        try {
            if (carId && name && value && value !== defValue) {
                this.setState({ loading: true })
                let input = {
                    id: carId,
                    [name]: name === "stage" ? renderEnumToInt(value) : value
                }
                this.props.apolloClient.mutate({
                    mutation: UpdateCarMutation,
                    variables: { input },
                }).then((result) => {
                    if (result && result.data && result.data.updateCar && result.data.updateCar.ok) {
                        this.setState({ editField: "", loading: false, error: "" })
                        this.props.refetchCarQuery()

                    } else if (result && result.data && result.data.updateCar && result.data.updateCar.errors && result.data.updateCar.errors[0] && result.data.updateCar.errors[0].messages) {
                        this.setState({ loading: false, error: result.data.updateCar.errors[0].messages.toString() })
                    } else {
                        this.setState({ loading: false, error: "Something went wrong, Please contact admin for support!" })
                    }
                }).catch((err) => {
                    this.setState({ loading: false, error: err.message })
                })
            } else if (value === this.state.value) {
                this.setState({ editField: "", loading: false, error: "" })
            }
        } catch (err) {
            this.setState({ loading: false, error: err })
        }
    }

    CreateDailyMileage = (carId, name, value) => {
        let defValue = this.state[name]
        try {
            if (carId && name && value && value !== defValue) {
                this.setState({ loading: true })
                let input = {
                    carId: carId,
                    lastMileage: this.props.car && this.props.car.branch && this.props.car.branch.defaultMileageUnit === "KM" ? { "mileage": parseFloat(value), "mileageUnit": "KM" } : { "mileage": parseFloat(value), "mileageUnit": "MI" }
                }
                this.props.apolloClient.mutate({
                    mutation: CreateDailyMileageMutation,
                    variables: { input },
                }).then((result) => {
                    if (result && result.data && result.data.createDailyMileage && result.data.createDailyMileage.ok) {
                        this.setState({ editField: "", loading: false, error: "" })
                        this.props.refetchCarQuery()

                    } else if (result && result.data && result.data.createDailyMileage && result.data.createDailyMileage.errors && result.data.createDailyMileage.errors[0] && result.data.createDailyMileage.errors[0].messages) {
                        this.setState({ loading: false, error: result.data.createDailyMileage.errors[0].messages.toString() })
                    } else {
                        this.setState({ loading: false, error: "Something went wrong, Please contact admin for support!" })
                    }
                }).catch((err) => {
                    this.setState({ loading: false, error: err.message })
                })
            } else if (value === this.state.value) {
                this.setState({ editField: "", loading: false, error: "" })
            }
        } catch (err) {
            this.setState({ loading: false, error: err })
        }
    }

    toggleSectionNav = (sectionName, value) => {
        this.setState({ [sectionName]: value })
    }

    render() {

        return (
            <>
                <div className="tab-container">
                    {this.props.loading ? <Loader /> : <>
                        <h4>CAR DETAILS</h4>
                        <div className="info-container">
                            <Row>
                                <Col>
                                    <Label>MODEL</Label>
                                    <Input disabled value={(this.props.car && this.props.car.carModel) ? toTitleCase(this.props.car.carModel.name) : "--"} />
                                </Col>
                                <Col>
                                    <Label>SERIES</Label>
                                    <Input disabled value={this.props.car && this.props.car.carModel && this.props.car.carModel.series ? this.props.car.carModel.series : "--"} />
                                </Col>
                                <Col>
                                    <Row>
                                        <Col xs={6}>
                                            <Label>GROUP</Label>
                                        </Col>
                                        {this.state.carModelGroups && this.state.carModelGroups.length > 1 &&
                                            <Col className="text-right" xs={6}>
                                                {this.state.editField !== "group" ?
                                                    <i className="fa fa-lg fa-pencil-square" onClick={() => this.editField("group", this.props && this.props.car && this.props.car.carModel ? this.props.car.carModel.groupType.id : "")}></i> :
                                                    <div>
                                                        {this.state.error && <><i id={"error-group"} className="fa fa-exclamation-circle danger" aria-hidden="true" /> <UncontrolledTooltip placement="bottom" target={"error-group"}>{this.state.error}</UncontrolledTooltip></>}&nbsp;&nbsp;
                                                        <i className="fa fa-solid fa-lg fa-times" onClick={() => this.editField("group")}></i>&nbsp;&nbsp;
                                                        <i className="fa fa-solid fa-lg fa-check" onClick={() => this.updateCar(this.props.car && this.props.car.id, "group", this.state.value)}></i>
                                                    </div>
                                                }

                                            </Col>
                                        }
                                    </Row>
                                    <div>
                                        {this.state.editField !== "group" &&
                                            <Input disabled={this.state.editField !== "group"} value={this.props.car && this.props.car.carModel && this.props.car.carModel.groupType ? this.props.car.carModel.groupType.name : "--"} />
                                        }
                                        {this.state.editField === "group" &&
                                            <FormGroup>
                                                <Input type="select" name="group" id="group" value={this.state.carModelGroupType} onChange={this.updateInput} placeholder="Model Group Type">
                                                    <option value="">Model Group Type</option>
                                                    {this.state.carModelGroups && this.state.carModelGroups && this.state.carModelGroups.map((carModelGroupType, i) =>
                                                        <option key={i} value={carModelGroupType.name}>{carModelGroupType.name}</option>
                                                    )}
                                                </Input>
                                            </FormGroup>
                                        }
                                    </div>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col xs={6}>
                                            <Label>COLOR</Label>
                                        </Col>
                                        <Col className="text-right" xs={6}>
                                            {this.state.editField !== "color" ?
                                                <i className="fa fa-lg fa-pencil-square" onClick={() => this.editField("color", this.props && this.props.car && this.props.car.color ? this.props.car.color : "")}></i> :
                                                <div>
                                                    <i className="fa fa-solid fa-lg fa-times" onClick={() => this.editField("color")}></i>&nbsp;&nbsp;
                                                    <i className="fa fa-solid fa-lg fa-check" onClick={() => this.updateCar(this.props.car && this.props.car.id, "color", this.state.value)}></i>
                                                </div>
                                            }

                                        </Col>
                                    </Row>
                                    <div>
                                        <>
                                            {this.state.editField !== "group" &&
                                                <Input disabled={this.state.editField !== "color"} defaultValue={this.props.car && this.props.car.color ? this.props.car.color : "--"} onChange={this.updateInput} />
                                            }
                                        </>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label>CREATED BY</Label>
                                    <Input disabled value={this.props.car && this.props.car.createdBy ? this.props.car.createdBy.firstName ? this.props.car.createdBy.firstName + " " + this.props.car.createdBy.lastName : this.props.car.createdBy.username : "--"} />
                                </Col>
                                <Col>
                                    <Label>CREATED AT</Label>
                                    <Input disabled value={this.props.car && this.props.car.dateAdded ? moment(this.props.car.dateAdded).tz("America/New_York").format(moment.HTML5_FMT.DATE) : "--"} />
                                </Col>
                                <Col>
                                    <Row>
                                        <Col xs={6}>
                                            <Label>Branch</Label>
                                        </Col>
                                        {(this.props.car && !(renderEnumToInt(this.props.car.stage) === 10 && this.props.car.branch && this.props.car.branch.customId === "BROOKLYN_NY")) &&
                                            <Col className="text-right" xs={6}>
                                                {this.state.editField !== "branch" ?
                                                    <i className="fa fa-lg fa-pencil-square" onClick={() => this.editField("branch", this.props && this.props.car && this.props.car.branch ? this.props.car.branch : "")}></i> :
                                                    <div>
                                                        {this.state.error && <><i id={"error" + this.props.car.id} className="fa fa-exclamation-circle danger" aria-hidden="true" /> <UncontrolledTooltip placement="bottom" target={"error" + this.props.car.id}>{this.state.error}</UncontrolledTooltip></>}&nbsp;&nbsp;
                                                        <i className="fa fa-solid fa-lg fa-times" onClick={() => this.editField("branch")}></i>&nbsp;&nbsp;
                                                        <i className="fa fa-solid fa-lg fa-check" onClick={() => this.updateCar(this.props.car && this.props.car.id, "branch", this.state.value)}></i>
                                                    </div>
                                                }

                                            </Col>
                                        }
                                    </Row>
                                    <div>
                                        {this.state.editField !== "branch" &&
                                            <Input disabled={this.state.editField !== "branch"} defaultValue={this.props.car && this.props.car.branch ? this.props.car.branch.name : "--"} />
                                        }
                                        {this.state.editField === "branch" &&
                                            <FormGroup>
                                                <Input style={{ width: "100%", padding: "5px", borderRadius: "5px" }} type="select" name="branch" id="branch" value={this.state.value} onChange={this.updateInput} placeholder="Branch">
                                                    <option value={this.state.branch.name}>Branch</option>
                                                    {this.props.allBranches && this.props.allBranches.edges.length > 0 && this.props.allBranches.edges.map((branch, i) =>
                                                        <option key={i} value={branch.node.name}>{branch.node.name}</option>
                                                    )}
                                                </Input>
                                            </FormGroup>
                                        }
                                    </div>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col xs={8}>
                                            <Label>CUSTOM NAME</Label>
                                        </Col>
                                        <Col className="text-right">
                                            {this.state.editField !== "customName" ?
                                                <i className="fa fa-lg fa-pencil-square" onClick={() => this.editField("customName", this.props && this.props.car && this.props.car.customName ? this.props.car.customName : "")}></i> :
                                                <div>
                                                    <i className="fa fa-solid fa-lg fa-times" onClick={() => this.editField("customName")}></i>&nbsp;&nbsp;
                                                    <i className="fa fa-solid fa-lg fa-check" onClick={() => this.updateCar(this.props.car && this.props.car.id, "customName", this.state.value)}></i>
                                                </div>
                                            }

                                        </Col>
                                    </Row>
                                    <Input disabled={this.state.editField !== "customName"} defaultValue={this.props.car && this.props.car.customName ? this.props.car.customName : "--"} onChange={this.updateInput} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label>LAST DMV INSPECTION</Label>
                                    <Input disabled value={this.props.car && this.props.car.lastDmvInspectionDate ? moment(this.props.car.lastDmvInspectionDate).tz("America/New_York").format(moment.HTML5_FMT.DATE) : "--"} />
                                </Col>
                                <Col>
                                    <Label>LAST OIL CHANGE DATE</Label>
                                    <Input disabled value={this.props.car && this.props.car.lastOilChangeDate ? moment(this.props.car.lastOilChangeDate).tz("America/New_York").format(moment.HTML5_FMT.DATE) : "--"} />
                                </Col>
                                <Col>
                                    <Label>MILES SINCE LAST OIL CHANGE</Label>
                                    <Input disabled value={this.props.car ? this.props.car.mileageSinceLastOilChange : "--"} />
                                </Col>
                                <Col>
                                    <Label>DAYS SINCE DMV</Label>
                                    <Input disabled value={this.props.car ? this.props.car.getDaysTillDmvInspection : "--"} />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={3}>
                                    <Row>
                                        <Col xs={8}>
                                            <Label>PLATE</Label>
                                        </Col>
                                        <Col className="text-right">
                                            <CopyToClipboard textToCopy={this.props.car && this.props.car.plate ? this.props.car.plate.dmvPlate : "--"} displayText={"dmv plate"} />
                                        </Col>
                                    </Row>
                                    <Input disabled value={this.props.car && this.props.car.plate ? this.props.car.plate.dmvPlate : "--"} />
                                </Col>
                                <Col xs={3}>
                                    <Row>
                                        <Col xs={8}>
                                            <Label>FHV</Label>
                                        </Col>
                                        <Col className="text-right">
                                            <CopyToClipboard textToCopy={this.props.car && this.props.car.plate ? this.props.car.plate.fhv : "--"} displayText={"fhv"} />
                                        </Col>
                                    </Row>
                                    <Input disabled value={this.props.car && this.props.car.plate ? this.props.car.plate.fhv : "--"} />
                                </Col>
                                <Col xs={3}>
                                    <Label>FHV EXPIRATION</Label>
                                    <Input disabled value={this.props.car && this.props.car.plate ? moment(this.props.car.plate.fhvExpiration).tz("America/New_York").format(moment.HTML5_FMT.DATE) : "--"} />
                                </Col>
                                <Col xs={3}>
                                    <Row>
                                        <Col xs={6}>
                                            <Label>LAST MILEAGE</Label>
                                        </Col>
                                        <Col className="text-right" xs={6}>
                                            {this.state.editField !== "lastMileage" ? (
                                                this.props.hasPermissions && this.props.hasPermissions.includes("add_dailymileage") && <i className="fa fa-lg fa-pencil-square" onClick={() => this.editField("lastMileage", this.props.car && this.props.car.lastMileage ? this.props.car.lastMileage : "")}></i>
                                            ) : (
                                                <div>
                                                    <i className="fa fa-solid fa-lg fa-times" onClick={() => this.editField("lastMileage")}></i>&nbsp;&nbsp;
                                                    <i className="fa fa-solid fa-lg fa-check" onClick={() => this.CreateDailyMileage(this.props.car.id, "lastMileage", this.state.value)}></i>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    {this.state.editField === "lastMileage" ?
                                        <Input
                                            disabled={this.state.editField !== "lastMileage"}
                                            defaultValue={this.props.car && this.props.car.lastMileage ? this.props.car.branch.defaultMileageUnit === "KM"
                                                ? parseFloat(this.props.car.lastMileageInKm).toFixed(2)
                                                : this.props.car.lastMileage
                                                : "--"
                                            }
                                            onChange={this.updateInput}
                                        /> :
                                        <div className="input-alternative-box">
                                            {this.props.car && this.props.car.lastMileage ? (
                                                this.props.car.branch.defaultMileageUnit === "KM" ? (
                                                    `${parseFloat(this.props.car.lastMileageInKm).toFixed(2)} KM`
                                                ) : (
                                                    `${parseFloat(this.props.car.lastMileage).toFixed(2)} MI`
                                                )
                                            ) : (
                                                "--"
                                            )}
                                        </div>}
                                </Col>

                            </Row>
                            <Row>
                                <Col xs={3}>
                                    <Row>
                                        <Col xs={6}>
                                            <Label>Car Location</Label>
                                        </Col>
                                        <Col className="text-right" xs={6}>
                                            {this.state.editField !== "carLocation" ?
                                                this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_edit_car_location") && <i className="fa fa-lg fa-pencil-square" onClick={() => this.editField("carLocation", this.props && this.props.car && this.props.car.carLocation ? this.props.car.carLocation : "")}></i> :
                                                <div>
                                                    {this.state.error && <><i id={"error" + this.props.car.id} className="fa fa-exclamation-circle danger" aria-hidden="true" /> <UncontrolledTooltip placement="bottom" target={"error" + this.props.car.id}>{this.state.error}</UncontrolledTooltip></>}&nbsp;&nbsp;
                                                    <i className="fa fa-solid fa-lg fa-times" onClick={() => this.editField("carLocation")}></i>&nbsp;&nbsp;
                                                    <i className="fa fa-solid fa-lg fa-check" onClick={() => this.updateCar(this.props.car && this.props.car.id, "locationId", this.state.value)}></i>
                                                </div>}
                                        </Col>
                                    </Row>
                                    <div>
                                        {this.state.editField !== "carLocation" &&
                                            <Input disabled={this.state.editField !== "carLocation"} defaultValue={this.props.car && this.props.car.carLocation ? this.props.car.carLocation.name : "--"} />
                                        }
                                        {this.state.editField === "carLocation" &&
                                            <FormGroup>
                                                <Input style={{ width: "100%", padding: "5px", borderRadius: "5px" }} type="select" name="carLocation" id="carLocation" value={this.state.value} onChange={this.updateInput} placeholder="Car Location">
                                                    <option value={this.state.carLocation?.id}>Car Location</option>
                                                    {this.props.allCarLocations && this.props.allCarLocations.edges.length > 0 && this.props.allCarLocations.edges.map((location, i) =>
                                                        <option key={i} value={location.node.id}>{location.node.name}</option>
                                                    )}
                                                </Input>
                                            </FormGroup>
                                        }
                                    </div>
                                </Col>
                                <Col>
                                    <div id={"carNotes"}>
                                        <Label>CAR NOTES</Label>&nbsp;&nbsp;
                                        <i onClick={() => this.toggleModal("carNotes")} className={"fa fa-pencil-square-o"}></i><br />
                                    </div>
                                    {this.state.openModal === "carNotes" &&
                                        <NotesHistory
                                            carId={this.props.car ? this.props.car.id : null}
                                            id={"carNotes"}
                                            target={"carNotes"}
                                            noteType="GENERAL"
                                            title="Car Notes History"
                                            open={this.state.openModal === "carNotes"}
                                            name={"notes"}
                                            handleClose={() => this.toggleModal("")}
                                            objectType={"carNotes"}
                                            objectId={""}
                                            refetchQuery={() => window.location.reload}
                                        />
                                    }
                                    <Input disabled
                                        value={this.props.car && this.props.car.notes}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <br /><br />
                        <h4>EQUIPMENTS</h4>
                        <div className="info-container">
                            <Row>
                                <Col>
                                    {this.props.car && this.props.car.equipmentSet && this.props.car.equipmentSet.edges && this.props.car.equipmentSet.edges.length > 0 ?
                                        <div className="equipments">
                                            {
                                                this.props.car.equipmentSet.edges.map((equipment, i) =>
                                                    <Badge style={{ marginRight: "5px" }} key={i} size="sm" color="black">
                                                        {equipment.node.equipmentItems && equipment.node.equipmentItems.name ? equipment.node.equipmentItems.name : "--"}
                                                    </Badge>)
                                            }
                                            <InstallEquipment open={this.state.openModal === "InstallEquipment"} pk={this.props && this.props.params && this.props.params.pk} handleClose={() => this.toggleModal("")} refetchQuery={this.props.refetchCarQuery} />
                                            <Badge color="success" onClick={() => this.toggleModal("InstallEquipment")} id={"InstallEquipment"}>
                                                <i className="fa fa-lg fa-plus" aria-hidden="true" />
                                                <UncontrolledTooltip target={"InstallEquipment"} >Add Equipment</UncontrolledTooltip>
                                            </Badge>
                                        </div>
                                        :
                                        <p>No Equipment Found!</p>
                                    }
                                </Col>
                            </Row>
                        </div>
                        <br /><br />
                        <Row>
                            <Col>
                                <div className="blue-highlighted-header">Enable - Disable History</div>
                                <div className="info-container enable-disable">
                                    <Row>
                                        {enableDisableHistoryTable.map(tableHeader =>
                                            <Col key={tableHeader.id}><Label>{tableHeader.name}</Label></Col>
                                        )}
                                    </Row>
                                    {this.props.car && this.props.car.caractionSet && this.props.car.caractionSet.edges && this.props.car.caractionSet.edges.length > 0 ? this.props.car.caractionSet.edges.map((action, i) =>
                                        <Row>
                                            <Col><p>{action.node.actionType ? action.node.actionType : "--"}</p></Col>
                                            <Col><p>{action.node.dateAdded ? <DatetimeRenderer datetime={action.node.dateAdded} /> : "--"}</p></Col>
                                            <Col><p>{action.node.status ? action.node.status : "--"}</p></Col>
                                            <Col><p>{action.node.representative ? action.node.representative : "--"}</p></Col>
                                        </Row>) : <Row><Col>No History Found!</Col></Row>
                                    }
                                </div>
                            </Col>
                        </Row>
                        <br /><br />
                        {this.props.car && this.props.car.currentAgreement &&
                            <>
                                <Row>
                                    <Col>
                                        <div className="green-highlighted-header">Active Car Rental</div>
                                        <div className="info-container" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}>
                                            <Row>
                                                <Col>
                                                    <Label>Driver Name</Label>
                                                    <p style={{ fontWeight: "600" }}>{this.props.car.currentAgreement.driver ? this.props.car.currentAgreement.driver.name : "---"} <Link color="primary" to={`/driver/${this.props.car.currentAgreement.driver.id}`} target="_blank" ><i className={"fa fa-external-link"}></i></Link> </p>
                                                </Col>
                                                <Col>
                                                    <Label>TLC License</Label>
                                                    <p>{this.props.car.currentAgreement.driver ? this.props.car.currentAgreement.driver.tlcLicense : "--"}</p>
                                                </Col>
                                                <Col>
                                                    <Label>Start Date</Label>
                                                    <p>{this.props.car.currentAgreement.startDate ? moment(this.props.car.currentAgreement.startDate).tz("America/New_York").format(moment.HTML5_FMT.DATE) : "--"}</p>
                                                </Col>
                                                <Col>
                                                    <Label>DMV License</Label>
                                                    <p> {this.props.car.currentAgreement.driver ? this.props.car.currentAgreement.driver.dmvLicense : "--"}</p>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <br /><br />
                            </>
                        }
                        {this.state.activeReservation &&
                            <>
                                <Row>
                                    <Col>
                                        <div className="green-highlighted-header">Active Reservation</div>
                                        <div className="info-container" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}>
                                            <Row>
                                                <Col>
                                                    <Label>Driver Name</Label>
                                                    <p style={{ fontWeight: "600" }}>{this.state.activeReservation && this.state.activeReservation.node && this.state.activeReservation.node.driver ? this.state.activeReservation.node.driver.name : "--"}</p>
                                                </Col>
                                                <Col>
                                                    <Label>Pickup Date</Label>
                                                    <p>{this.state.activeReservation && this.state.activeReservation.node && this.state.activeReservation.node.pickupDate ? moment(this.state.activeReservation.node.pickupDate).tz("America/New_York").format(moment.HTML5_FMT.DATE) : "--"}</p>
                                                </Col>
                                                <Col>
                                                    <Label>Deposit</Label>
                                                    <p>{toTitleCase(this.state.activeReservation.depositScheme)} - {`$${this.state.activeReservation.depositAmount}`}</p>
                                                </Col>
                                                <Col>
                                                    <Label>Payment Method</Label>
                                                    <p>{this.state.activeReservation && this.state.activeReservation.node && this.state.activeReservation.node.paymentMethod && this.state.activeReservation.node.paymentMethod.name ? this.state.activeReservation.node.paymentMethod.name : "--"}</p>
                                                </Col>
                                                <Col>
                                                    <Label>Created By</Label>
                                                    <p>{this.state.activeReservation && this.state.activeReservation.node && this.state.activeReservation.node.rep ? this.state.activeReservation.node.rep.firstName ? this.state.activeReservation.node.rep.firstName + " " + this.state.activeReservation.node.rep.lastName : this.state.activeReservation.node.rep.username : "--"}</p>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <br /><br />
                            </>
                        }
                        <h4>INTEGRATIONS</h4>
                        <div className="info-container">
                            <Row>

                                <Col>
                                    <Label>Clobber</Label>
                                    <p>
                                        <Button className="primary" onClick={() => this.toggleModal("cloberDetails")}>
                                            CLOBBER DETAILS&nbsp;&nbsp;<i id={"cloberDetails"} className="fa fa-info-circle" aria-hidden="true"></i>
                                        </Button>
                                        {this.state.openModal === "cloberDetails" &&
                                            <ClobberDetailsModal
                                                isOpen={this.state.openModal === "cloberDetails"}
                                                handleClose={() => this.toggleModal("cloberDetails")}
                                                carPk={this.props.car.pk}
                                                vin={this.props.car.vin}
                                            />
                                        }
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </>}
                </div >
            </>
        )
    }
}


//-----------------------------------
export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: ["add_dailymileage", "custom_can_edit_car_location"] },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loading,
        variables,
    }),
})(
    graphql(AllCarModelGroupTypes, {
        props: ({ data: { allCarModelGroupTypes } }) => ({
            allCarModelGroupTypes,
        }),
    })(
        graphql(AllCarModelsQuery, {
            props: ({ data: { allCarModels } }) => ({
                allCarModels,
            }),
        })(
            graphql(AllBranchesQuery, {
                options: {
                    fetchPolicy: 'cache-and-network',
                },
                props: ({ data: { allBranches, fetchMore } }) => ({
                    allBranches,
                    refetchAllBranches: () =>
                        fetchMore({
                            query: AllBranchesQuery,
                            updateQuery: (previousResult, { fetchMoreResult }) => {
                                const newEdges = fetchMoreResult.allBranches.edges
                                const pageInfo = fetchMoreResult.allBranches.pageInfo

                                return {
                                    allBranches: {
                                        edges: [...newEdges],
                                        pageInfo,
                                        searchTerm: previousResult.searchTerm,
                                        __typename: previousResult.allBranches.__typename,
                                    },
                                }
                            },
                        }),
                }),
            })(
                graphql(CarDetailQuery, {
                    options: (props) => ({
                        variables: { pk: parseInt(props?.params?.pk, 10) },
                    }),
                    props: ({ data: { car, loading, refetch, variables } }) => ({
                        car,
                        loading,
                        variables,
                        refetchCarQuery: () =>
                            refetch({
                                query: CarDetailQuery,
                                variables: { ...variables },
                                updateQuery: (previousResult, { fetchMoreResult }) => ({
                                    car: fetchMoreResult.car,
                                }),
                            }),
                    }),
                })(
                    graphql(AllCarLocationsQuery, {
                        options: {
                            fetchPolicy: 'cache-and-network',
                        },
                        props: ({ data: { allCarLocations } }) => ({
                            allCarLocations,
                        }),
                    })(withApolloClient(OverviewTab))
                )
            )
        )
    )
)
